import React from "react";
import { Loading, MessageBanner } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { usePeriodicalKultSubjectGroup } from "../../hooks/usePeriodicalKultSubjectGroup";
import { KultSubjectGroupBadge } from "./KultSubjectGroupBadge";
import css from "./KultSubjectGroupBadge.module.css";
export var PeriodicalKultSubjectGroupValue = function (_a) {
    var _b;
    var current = _a.current;
    return (React.createElement(React.Fragment, null,
        current.code &&
            "".concat(current.group, ". ").concat(current.code, " ").concat((_b = current.label) !== null && _b !== void 0 ? _b : ""),
        React.createElement(KultSubjectGroupBadge, { origin: current.origin, overrideOrphaned: current.overrideOrphaned, orphanedOverrideCode: current.orphanedOverrideCode, unescoCode: current.unescoCode }),
        current.unescoCode && current.origin !== "UNESCO" && (React.createElement("span", { className: css.unescoCode, "data-testid": "kult-subject-group-unesco-code" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.unescoCode", values: { code: current.unescoCode } })))));
};
export var PeriodicalKultSubjectGroupLine = function (_a) {
    var titleId = _a.titleId;
    var _b = usePeriodicalKultSubjectGroup(titleId), data = _b.data, isLoading = _b.isLoading, isError = _b.isError;
    return (React.createElement(React.Fragment, null,
        React.createElement("strong", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.field.label" }),
            ":"),
        " ",
        isLoading ? (React.createElement("div", { className: css.loading },
            React.createElement(Loading, null))) : isError || !data ? (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.kultSubjectGroup.error.load" }))) : (React.createElement(PeriodicalKultSubjectGroupValue, { current: data }))));
};
